import React from 'react';
import { Field } from '@cordata/buffet';
import { Row, Col } from 'reactstrap';

const ReportFilter = ({
  type,
  label,
  endDateLabel,
  startDateLabel,
  options,
  isMultiSelect,
  selectProps,
  i,
  filter,
}) => {
  if (type === 'date range') {
    return (
      <Row form>
        <Col sm>
          <Field
            label={startDateLabel}
            name={`${i}.startDate`}
            type="date"
          />
        </Col>

        <Col sm>
          <Field
            label={endDateLabel}
            name={`${i}.endDate`}
            type="date"
          />
        </Col>
      </Row>
    );
  } else if (type === 'checkbox') {
    return (<>
      <Field
        label={label}
        name={`${i}.selected`}
        type="checkbox"
      />
    </>);
  } else if (type === 'badge') {
    return (<>
      <Field
        label={label}
        name={`${i}.selected`}
        type="select"
        options={options}
        multi
        closeMenuOnSelect={false}
        text={
          <Field
            name={`${i}.filterByAllBadges`}
            label={false}
            placeholder="Include patients that have any of the selected badges"
            options={[{
              label: 'Include patients that have any of the selected badges',
              value: false,
            }, {
              label: 'Only include patients that have all of the selected badges',
              value: true,
            }]}
            type="radio-group"
            inline
          />
        }
      />
    </>);
  } else if (type === 'boolean radio buttons') {
    return (
      <Field
        name={`${i}.selected`}
        label={label}
        options={[{
          label: filter.radioButtonOptionAll || 'All',
          value: 'all',
        }, {
          label: filter.radioButtonOptionTrue || 'True',
          value: 'true',
        }, {
          label: filter.radioButtonOptionFalse || 'False',
          value: 'false',
        }]}
        type="radio-group"
        inline
      />
    );

  } else if (type === 'number') {
    return (<>
      <Field
        label={label}
        name={`${i}.value`}
        type="number"
      />
    </>);
  } else if (type === 'string') {
    return (<>
      <Field
        label={label}
        name={`${i}.value`}
      />
    </>);
  }

  return (<>
    <Field
      label={label}
      name={`${i}.selected`}
      type="select"
      options={options}
      multi={isMultiSelect}
      closeMenuOnSelect={!isMultiSelect}
      {...selectProps}
    />
  </>);
};

export default ReportFilter;
